module.exports = __webpack_public_path__ + "static/media/clouds.7de5542c.svg";